import { useCurrency } from '../contexts/CurrencyContext';

export default function CurrencyToggle({ compact = false }) {
  const { currency, setCurrency, currencies } = useCurrency();
  const codes = Object.keys(currencies);

  return (
    <div
      className={`inline-flex items-center border border-white/15 ${compact ? 'text-[10px]' : 'text-xs'}`}
      data-testid="currency-toggle"
    >
      {codes.map((code, idx) => (
        <button
          key={code}
          onClick={() => setCurrency(code)}
          data-testid={`currency-toggle-${code}`}
          className={`${compact ? 'px-2 py-1' : 'px-2.5 py-1.5'} font-sans tracking-wider transition-colors ${
            currency === code
              ? 'bg-[#D4AF37] text-black font-medium'
              : 'text-white/60 hover:text-white'
          } ${idx > 0 ? 'border-l border-white/10' : ''}`}
        >
          {currencies[code].label}
        </button>
      ))}
    </div>
  );
}
